module.exports = __webpack_public_path__ + "static/media/home.724d4af0.jpg";